import { dictByCodeServer } from '@/api/dict';
import { getMaterialList } from '@/api/material';
import { isEmpty } from '@/utils/is.js';
import { useDialog } from '@/components/dialog/index';
import MaterialDetails from '@/views/firefighting/dangerousGoodsInfo/details.vue';
import VocCasDetails from '@/views/realdata/components/voc-cas.vue';
import GasCasDetails from '@/views/realdata/components/flammable-gas-cas.vue';

export default {
  data() {
    return {
      pageLoading: false,
      loadingText: '加载物质详情中，请稍后...'
    };
  },
  methods: {
    async handleSubstanceFlow(casName) {
      if (['-', '剂量率'].includes(casName)) return;
      try {
        this.pageLoading = true;

        if (['挥发有机物', '可燃气体'].includes(casName)) {
          useDialog({
            title: this.$t('物质详情'),
            width: '75vw',
            marginTop: '5vh',
            slots: {
              default: () => (
                <div style="height:76vh;">
                  {casName.includes('挥发有机物') ? <VocCasDetails /> : <GasCasDetails />}
                </div>
              )
            }
          });
        } else {
          // 1. 获取CAS字典数据
          const casData = await dictByCodeServer('device_cas');
          const { data: casList } = casData;

          const casItem = casList.filter(item => {
            return item.label === casName;
          });

          if (isEmpty(casItem)) return this.$message.warning('未找到对应的CAS编号');

          // 2. 检查是否存在
          let params = {
            libCode: 'fda',
            keyword: casItem[0].value,
            offset: 1,
            limit: 10
          };
          const checkResult = await getMaterialList(params);
          if (isEmpty(checkResult.data.list)) return this.$message.warning('该物质不存在于列表中');

          // 3. 获取详情 找出具体id 传值给 dialog组件
          useDialog({
            title: this.$t('物质详情'),
            width: '75vw',
            marginTop: '5vh',
            slots: {
              default: () => (
                <div style="height:76vh;">
                  <MaterialDetails materialId={checkResult.data.list[0].id} />
                </div>
              )
            }
          });
        }
      } catch (error) {
        this.$message.error('获取物质信息失败');
        console.error(error);
      } finally {
        this.pageLoading = false;
      }
    }
  }
};
